module.exports = __webpack_public_path__ + "static/media/uph_0002.f54c95b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fabrics/uph_0002.jpg
// module id = 633
// module chunks = 0